module.exports = function anonymous(it
) {
var out='<!-- created by panjm on 2019-10-24 description： 左侧菜单模版-->';if(it && it.menu){out+='<div class="spzx_leftmenu bfff">';var arr1=it.menu;if(arr1){var item,index=-1,l1=arr1.length-1;while(index<l1){item=arr1[index+=1];out+='<div class="menu_block"><h5>'+(item.name || "")+'<i class="iconfont spzx-icon-arrowd fr ';if(index === 0){out+='on';}out+='"></i></h5><ul ';if(index === 0){out+='style="display: block;"';}out+='>';var arr2=item.children;if(arr2){var sitem,sindex=-1,l2=arr2.length-1;while(sindex<l2){sitem=arr2[sindex+=1];out+='<li data-url="'+(sitem.url || '')+'" class="'+(it.curUrl.indexOf(sitem.url) >= 0 ? 'lgc_cyan' : '')+'">'+(sitem.name || "")+'</li>';} } out+='</ul></div>';} } out+='</div>';}return out;
}


//////////////////
// WEBPACK FOOTER
// ./src/template/dot/layout/left/module/left.dot
// module id = 53
// module chunks = 0 1 2